import platform from 'platform';
import { asyncLocalStorage } from 'server/utils/async-local-storage';

type Platform = typeof platform;

let clientUserAgentCache: Platform;
let serverUserAgentCache: Map<string, Platform>;

if (__SERVER__) {
  serverUserAgentCache = new Map<string, Platform>();
}

const MAX_SERVER_CACHE_SIZE = 1000;

/**
 * @return platform object
 */
export const userAgent = (): Platform => {
  if (__SERVER__) {
    const requestContext = asyncLocalStorage.getStore();
    const rawUserAgent: string = requestContext?.get('userAgent') ?? '';

    if (serverUserAgentCache.has(rawUserAgent)) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return serverUserAgentCache.get(rawUserAgent)!;
    }

    const parsedUserAgent = platform.parse(rawUserAgent);

    if (serverUserAgentCache.size >= MAX_SERVER_CACHE_SIZE) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const firstKey = serverUserAgentCache.keys().next().value!;
      serverUserAgentCache.delete(firstKey);
    }

    serverUserAgentCache.set(rawUserAgent, parsedUserAgent);

    return parsedUserAgent;
  }

  if (typeof clientUserAgentCache !== 'undefined') {
    return clientUserAgentCache as Platform;
  }

  const rawUserAgent = navigator.userAgent;
  clientUserAgentCache = platform.parse(rawUserAgent);

  return clientUserAgentCache;
};
